interface DriverConfirmationTheme {
  textFontSize: number | string;
  TextColor: string;
}

const styles = (theme: DriverConfirmationTheme) => ({
  sectionContainer: {
    marginTop: 8
  },
  toggleRow: {
    display: 'flex' as const,
    justifyContent: 'space-between' as const,
    alignItems: 'center' as const,
    flexWrap: 'nowrap' as const,
    marginBottom: 0,
    '& > div': {
      flexShrink: 0
    }
  },
  helperText: {
    display: 'block' as const,
    margin: '4px 0 8px',
    fontSize: theme.textFontSize,
    lineHeight: '18px',
    color: theme.TextColor,
    opacity: 0.8
  },
  promptConfirmationContainer: {
    paddingBottom: 20
  },
  sectionDisabled: {
    opacity: 0.7
  },
  disabledToggleWrapper: {
    display: 'inline-block',
    width: '100%',
    cursor: 'not-allowed'
  }
});

export default styles;
